<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="cargando">
      <b-button variant="primary" disabled>
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>
    </div>

    <div v-else>
      <b-alert v-if="itemsHistorial == 0" variant="danger" show>
        No hay datos
      </b-alert>

      <div v-else>
        <b-form-input
          v-model="filtrado"
          type="search"
          class="mb-4"
          placeholder="Buscar por número de orden"
        >
        </b-form-input>
        <b-table
          sticky-header
          striped
          hover
          thead-tr-class="columnas"
          :items="itemsHistorial"
          :fields="titulosHistorial"
          :filter="filtrado"
          :per-page="perPageHistorial"
          :current-page="currentPageHistorial"
        >
          <template v-slot:cell(numeroOrden)="row">
            <a
              class="punteroMano"
              v-b-popover.hover.top="'Detalle'"
              @click="traerDetalle(row.item)"
            >
              {{ row.item.numeroOrden }}
            </a>
          </template>
          <template v-slot:cell(fechaAlta)="row">
            {{ row.item.fechaAlta | formatoFecha }}
          </template>
          <template v-slot:cell(fechaAutorizacion)="row">
            {{ row.item.fechaAutorizacion | formatoFecha }}
          </template>
          <template v-slot:cell(monto)="row">
            {{ row.item.monto | moneda }}
          </template>
          <template v-slot:cell(acciones)="row">
            <b-button-group v-if="permiteAutorizar || !ordinario">
              <b-button
                v-b-popover.hover.left="'Autorizar'"
                variant="outline-primary"
                v-on:click="modalAutorizacion(row.item)"
                :disabled="row.item.estatusRequisicion != 2"
              >
                <b-icon icon="hand-thumbs-up"> </b-icon>
              </b-button>

              <b-button
                v-b-popover.hover.top="'Editar'"
                variant="outline-warning"
                v-on:click="editarRequisicion(row)"
                :disabled="row.item.estatusRequisicion != 2"
                v-if="$localStorageService.can('RQ_02_Edit_req')"
              >
                <b-icon icon="justify"> </b-icon>
              </b-button>
            </b-button-group>
            <b-button variant="outline-primary" disabled v-else>
              <b-icon icon="dash-circle-fill"> </b-icon>
            </b-button>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPageHistorial"
          :total-rows="itemsHistorial.length"
          :per-page="perPageHistorial"
        ></b-pagination>
      </div>
    </div>
    <b-modal ref="autorizar" title="Autorizar Orden" size="xl" hide-footer>
      <autorizarRequisicion
        :requisicion="requisicion"
        :producto="requisicionParaAutorizar"
        :ordinario="ordinario"
      />
    </b-modal>

    <b-modal ref="detalle" :title="'Orden ' + numOrden" size="xl" hide-footer>
      <detalleOrden :producto="requisicionParaAutorizar" />
    </b-modal>
  </div>
</template>

<script>
import autorizarRequisicion from "./Autorizar.vue";
import detalleOrden from "./DetalleOrdinario.vue";

export default {
  name: "HistorialSolicitud",
  components: {
    autorizarRequisicion,
    detalleOrden,
  },
  props: {
    ordinario: {
      type: Boolean,
      require: true,
    },
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    requisicion: null,
    idRequisicion: null,
    itemsHistorial: [],
    filtrado: null,
    perPageHistorial: 10,
    currentPageHistorial: 1,
    requisicionParaAutorizar: [],
    titulosHistorial: [
      {
        key: "numeroOrden",
        label: "Número de orden",
        sortable: true,
      },
      {
        key: "fechaAlta",
        label: "fecha Solicitud",
        sortable: true,
      },
      {
        key: "fechaAutorizacion",
        label: "fecha Autorización",
        sortable: true,
      },
      {
        key: "clinica",
        label: "Clínica",
      },
      {
        key: "monto",
        label: "Monto Autorizado",
      },
      {
        key: "nombreEstatus",
        label: "Estatus Requisición",
        sortable: true,
      },
      {
        key: "acciones",
        label: "Acciones",
      },
    ],
    numOrden: null,
    cargando: true,
    permiteAutorizar: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerHistorial();

    const inicio = new Date();
    const fin = new Date();
    const hoy = new Date();

    inicio.setDate(inicio.getDate() - inicio.getDay() + 1);
    inicio.setHours(0);
    inicio.setMinutes(0);
    inicio.setSeconds(0);

    fin.setDate(fin.getDate() - fin.getDay() + 6);
    fin.setHours(20);
    fin.setMinutes(0);
    fin.setSeconds(0);

    if (inicio.getTime() < hoy.getTime() && hoy.getTime() < fin.getTime()) {
      this.permiteAutorizar = true;
    }
  },
  methods: {
    obtenerHistorial() {
      let peticion =
        this.$api +
        "requisiciones/coordinador?" +
        "idColaborador=" +
        this.$localStorageService.getIdEmpleado() +
        "&ordinario=" +
        this.ordinario;

      this.$http
        .get(peticion)
        .then((response) => {
          if (response.status == 200) {
            this.itemsHistorial = response.data.data;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    modalAutorizacion(row) {
      let autorizar = {
        idRequisicion: row.idRequisicion,
        clinica: row.clinica,
        numeroOrden: row.numeroOrden,
        fechaAlta: row.fechaAlta,
      };

      this.requisicion = autorizar;
      this.requisicionParaAutorizar = row.productos;
      this.$refs["autorizar"].show();
    },
    editarRequisicion(row) {
      this.$session.set("producto", row.item.productos);
      this.$router.push({
        name: "EditarRequisicion",
        params: {
          idRequisicion: row.item.idRequisicion,
          ordinario: this.ordinario,
        },
      });
    },
    traerDetalle(registro) {
      this.numOrden = registro.numeroOrden;
      this.requisicionParaAutorizar = registro.productos;
      this.$refs["detalle"].show();
    },
  },
};
</script>

<style>
</style>